import { render, staticRenderFns } from "./champ_tinytext.vue?vue&type=template&id=e6973392"
import script from "./champ_tinytext.js?vue&type=script&lang=js&external"
export * from "./champ_tinytext.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports